import { useSelector } from 'react-redux';
import { paramsGetTipoCambioSUNAT } from '../../bussines/params/TipoCambioSUNAT.params';
import { TipoCambioSUNATDatasource } from '../../data/datasources/TipoCambioSUNAT.datasource';
import { toast } from 'lib.front';

const useTiposCambio = () => {
   const usuario = useSelector((state: any) => state.auth.usuario);
   const apikey = usuario?.key;
   const enabled = !!apikey;

   const getTipoCambioSUNAT = async (params: paramsGetTipoCambioSUNAT) => {
      try {
         const datasource = new TipoCambioSUNATDatasource(apikey);
         const response = await datasource.getTipoCambioSUNAT(params);
         return response;
      } catch (err) {
         const message = err instanceof Error ? err.message : String(err);
         return message;
      }
   };

   return { getTipoCambioSUNAT, enabled };
};

export default useTiposCambio;